import Loader from "components/loader/Loader";
import { helper } from "lib/helper";
import adminModel from "models/admin.model";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";

const AddCategory = () => {
  const [categoryName, setCategoryName] = useState("");
  const [priority, setPriority] = useState(1); // Default to a numeric value
  const [icon, setIcon] = useState(null); // for image/icon file
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  // Placeholder function to handle category addition
  const handleAddCategory = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    const fromData = new FormData();
    fromData.append("name", categoryName);
    fromData.append("priority", priority);
    fromData.append("image", icon);

    try {
      const res = await adminModel.createExperienceCategory(fromData);
      helper.sweetalert.toast("Category Added successfully!");
      setCategoryName("");
      setPriority(1);
      setIcon(null);
      navigate('/admin/experience-categories');
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      helper.sweetalert.error("Something went wrong, Please try again later!");
      setIsLoading(false);
    }

  };

  // Handle file input change
  const handleIconChange = (e) => {
    const selectedFile = e.target.files[0];
    setIcon(selectedFile);
  };

  return isLoading ? <Loader /> : (
    <>
      <Container className="pt-7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Add New Tags</h3>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleAddCategory}>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label for="categoryName">Tag Name</Label>
                        <Input
                          type="text"
                          id="categoryName"
                          value={categoryName}
                          onChange={(e) => setCategoryName(e.target.value)}
                          placeholder="Enter Tag name"
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label for="priority">Priority</Label>
                        <Input
                          type="number" // Changed to number type
                          id="priority"
                          value={priority}
                          onChange={(e) => setPriority(Number(e.target.value))} // Convert to number
                          min="1" // Minimum priority value
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label for="icon">Icon / Image</Label>
                        <Input
                          type="file"
                          id="icon"
                          onChange={handleIconChange}
                          accept="image/*"
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Button color="primary" type="submit">
                    Add Category
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddCategory;
